<div class="p-4">
  <div class="form-group">
    <label for="title">Titulo</label>
    <input
      type="text"
      class="form-control"
      name="title"
      [(ngModel)]="title"
      id="title"
      placeholder="Ej. Revisión de parsela #21"
    />
  </div>

  <label for="title">Fecha</label>
  <div class="d-flex justify-content-between align-items-center mb-3">
    <!-- NgbDatepicker para seleccionar la fecha -->
    <div class="input-group mr-3">
      <input
        class="form-control"
        placeholder="yyyy-mm-dd"
        name="dp"
        [(ngModel)]="selectedDate"
        [ngModelOptions]="{ standalone: true }"
        ngbDatepicker
        #d="ngbDatepicker"
        [positionTarget]="buttonEl"
      />
      <button
        #buttonEl
        class="btn btn-outline-success btn-sm"
        (click)="d.toggle()"
        type="button"
      >
        <i class="fa fa-calendar" aria-hidden="true"></i>
      </button>
    </div>
    <ngb-timepicker
      [(ngModel)]="selectedTime"
      [ngModelOptions]="{ standalone: true }"
      [seconds]="false"
      [spinners]="false"
    ></ngb-timepicker>
  </div>

  <span class="text-danger" *ngIf="!isDateInRange()"
    >No puedes seleccionar una fecha fuera del ciclo</span
  >

  <div class="form-group mt-3">
    <label for="observation">Observación</label>
    <textarea
      class="form-control"
      name="observation"
      [(ngModel)]="observation"
      id="observation"
      rows="3"
    ></textarea>
  </div>
  <div class="form-group">
    <div class="d-flex flex-column align-items-center" style="gap: 10px">
      <button
        class="btn"
        (click)="clickViewReport()"
        [class]="selectedPosition ? 'btn-primary' : 'btn-dark'"
      >
        <img width="20" [src]="iconReport.url" />
        {{ selectedPosition ? "Seleccionando" : "Selecciona" }} ubicación del
        reporte
      </button>

      <ng-container *ngIf="selectedPosition && !position">
        <small>Has click en el sector para asignar ubicación al reporte</small>
      </ng-container>
    </div>

    <ng-container *ngIf="position">
      <div class="d-flex gap-10 mt-3">
        <div class="d-flex flex-column">
          <span>Latitud</span>
          <input
            type="text"
            disabled
            class="form-control"
            name="area"
            [value]="position.lat"
          />
        </div>
        <div>
          <span>Longitud</span>
          <input
            type="text"
            disabled
            class="form-control"
            name="area"
            [value]="position.lng"
          />
        </div>
      </div>
    </ng-container>
  </div>

  <div class="form-group">
    <label for="observation">Área</label>
    <input
      type="number"
      class="form-control"
      name="area"
      [(ngModel)]="reportsService.areaReport"
      id="area"
    />
  </div>

  <!-- Imagenes -->
  <div class="rectangle mt-3">
    <div class="row">
      <div class="col-12">
        <h5 for="images">Imágenes</h5>
      </div>
      <div class="col-12">
        <div class="form-group" style="margin-bottom: 0rem">
          <app-image-cropper
            [type]="'file'"
            (setbase64)="getImageCropper($event)"
          >
          </app-image-cropper>
          <div class="center mt-3">
            <button
              class="btn btn-success btn-sm"
              *ngIf="filePhoto"
              (click)="addImageToList()"
            >
              Agregar <i class="fa fa-plus" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="col-12 mt-1">
        <div
          class="image-container d-flex"
          style="height: 100%"
          *ngIf="base64Images.length > 0"
        >
          <div
            style="height: 70px; width: 70px; position: relative"
            class="mx-1"
            *ngFor="let image of base64Images; let i = index"
          >
            <img
              [src]="image.image"
              alt="image-array"
              style="height: inherit; width: inherit"
              srcset=""
            />
            <span
              class="badge badge-danger pos-trash"
              style="cursor: pointer"
              (click)="removeImage(image.image, i)"
            >
              <i class="fa fa-trash" aria-hidden="true"></i
            ></span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Multimedia -->
  <div class="rectangle mt-3">
    <div class="row">
      <div class="col-12 d-flex flex-column">
        <h5 for="multimedia">Mulimedia</h5>
        <div
          class="btn-group"
          name="multimedia"
          id="multimedia"
          role="group"
          aria-label="Basic example"
        >
          <button
            type="button"
            class="btn btn-sm"
            (click)="multimediaType = 1"
            [class]="multimediaType === 1 ? 'btn-dark' : 'btn-outline-dark'"
          >
            Video
          </button>
          <button
            type="button"
            class="btn btn-sm"
            (click)="multimediaType = 2"
            [class]="multimediaType === 2 ? 'btn-dark' : 'btn-outline-dark'"
          >
            Audio
          </button>
        </div>
      </div>
      <div class="col-12 mt-2" *ngIf="multimediaType === 1">
        <input
          type="file"
          (change)="fileReady($event)"
          *ngIf="!video"
          accept="video/mp4,video/x-m4v,video/*"
        />
        <div class="center flex-column">
          <video width="320" *ngIf="video" height="240" controls>
            <source [src]="video" type="video/mp4" />
          </video>
          <button
            class="btn btn-danger mt-1"
            *ngIf="video"
            (click)="removeMultimedia('video', video)"
          >
            <i class="fa fa-trash" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <div class="col-12 mt-2" *ngIf="multimediaType === 2">
        <input
          type="file"
          (change)="fileReady($event)"
          *ngIf="!audio"
          accept="audio/*"
        />
        <div class="center flex-column">
          <audio *ngIf="audio" class="w-100 mt-2" controls>
            <source [src]="audio" type="audio/ogg" />
            <source [src]="audio" type="audio/mpeg" />
          </audio>
          <button
            class="btn btn-danger mt-1"
            *ngIf="audio"
            (click)="removeMultimedia('audio', audio)"
          >
            <i class="fa fa-trash" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12 mt-3 center">
    <app-loading
      [type]="'Reporte'"
      [vh]="'h-0vh'"
      *ngIf="loading"
    ></app-loading>
    <button
      [disabled]="validateForm()"
      (click)="submitReport()"
      type="submit"
      class="btn btn-primary"
      *ngIf="!loading"
    >
      Finalizar
    </button>
  </div>

  <!-- Incidencias -->
  <div class="rectangle mt-3">
    <div class="row">
      <div class="col-10">
        <h5 class="mb-0">Incidencias</h5>
        <small>Una vez registrada la incidencia no podrá modificarse.</small>
      </div>
      <div class="col-2 center">
        <div class="btn btn-success" type="button" (click)="addIncidence()">
          <i class="fa fa-plus" aria-hidden="true"></i>
        </div>
      </div>
    </div>

    <div class="row my-3">
      <div class="col-12" style="overflow: auto">
        <div class="btn-group" role="group" aria-label="Basic example">
          <button
            type="button"
            (click)="changeIncidence(i)"
            *ngFor="let incidence of incidenceArray; let i = index"
            class="btn btn-sm"
            [class]="selectedIncidence === i ? 'btn-dark' : 'btn-outline-dark'"
          >
            {{ i + 1 }}
          </button>
        </div>
      </div>
      <ng-container
        *ngIf="incidenceArray[selectedIncidence]?.cantEdit != true; else other"
      >
        <div class="col-12 mt-1" *ngIf="incidenceArray.length > 0">
          <button class="btn btn-danger btn-sm" (click)="removeIncidence()">
            Remover incidencia
          </button>
        </div>
      </ng-container>
      <ng-template #other>
        <div class="col-12 mt-2">
          <p>Esta incidencia no puede ser editada</p>
        </div>
      </ng-template>
    </div>

    <div class="row mt-1" *ngIf="incidenceArray.length > 0">
      <div class="col-12">
        <div class="form-group">
          <label for="typeIncidence">Tipo de incidencia</label>
          <select
            [disabled]="incidenceArray[selectedIncidence]?.cantEdit == true"
            class="form-control"
            [(ngModel)]="incidenceArray[selectedIncidence].type"
            name="typeIncidence"
            id="typeIncidence"
          >
            <option value="T">Tecnica</option>
            <option value="A">Agricola</option>
          </select>
        </div>
      </div>
      <div
        [class]="
          incidenceArray[selectedIncidence].type == 'A' ? 'col-6' : 'col-12'
        "
      >
        <div class="form-group">
          <label for="incidenceName">Nombre de incidencia</label>
          <select
            class="form-control"
            [disabled]="incidenceArray[selectedIncidence]?.cantEdit == true"
            [(ngModel)]="incidenceArray[selectedIncidence].name"
            name="incidenceName"
            id="incidenceName"
          >
            <option value="" selected>Seleccionar indicencia</option>
            <ng-container *ngIf="incidenceArray[selectedIncidence].type == 'A'">
              <option
                *ngFor="let incidence of incidencesAList"
                [value]="incidence.name"
              >
                {{ incidence.name }}
              </option>
            </ng-container>
            <ng-container *ngIf="incidenceArray[selectedIncidence].type == 'T'">
              <option
                *ngFor="let incidence of incidencesTList"
                [value]="incidence.name"
              >
                {{ incidence.name }}
              </option>
            </ng-container>
          </select>
        </div>
        <div
          class="form-group"
          *ngIf="incidenceArray[selectedIncidence].type == 'A'"
        >
          <label for="incidenceAmount">Cantidad encontradas</label>
          <input
            type="text"
            class="form-control"
            [disabled]="incidenceArray[selectedIncidence]?.cantEdit == true"
            [(ngModel)]="incidenceArray[selectedIncidence].amount"
            name="incidenceAmount"
            id="incidenceAmount"
            aria-describedby="incidenceAmount"
            placeholder="#"
          />
          <small id="incidenceAmount" class="form-text text-muted"
            >No aplica en todos los casos.</small
          >
        </div>
        <div class="form-group">
          <label for="incidenceDescription">Descripción</label>
          <textarea
            class="form-control"
            [disabled]="incidenceArray[selectedIncidence]?.cantEdit == true"
            [(ngModel)]="incidenceArray[selectedIncidence].description"
            name="incidenceDescription"
            id="incidenceDescription"
            rows="3"
          ></textarea>
        </div>
      </div>
      <div
        [class]="incidenceArray[selectedIncidence].type == 'A' ? 'col-6' : ''"
        *ngIf="incidenceArray[selectedIncidence].type == 'A'"
      >
        <div class="form-group">
          <label for="incidencePlantFruit">Fruta</label>
          <select
            class="form-control"
            [disabled]="incidenceArray[selectedIncidence]?.cantEdit == true"
            [(ngModel)]="incidenceArray[selectedIncidence].fruit"
            name="incidencePlantFruit"
            id="incidencePlantFruit"
          >
            <option value="3">Rojo</option>
            <option value="2">Amarillo</option>
            <option value="1">Verde</option>
          </select>
        </div>
        <div class="form-group">
          <label for="incidencePlantPlant">Planta</label>
          <select
            class="form-control"
            [disabled]="incidenceArray[selectedIncidence]?.cantEdit == true"
            [(ngModel)]="incidenceArray[selectedIncidence].plant"
            name="incidencePlantPlant"
            id="incidencePlantPlant"
          >
            <option value="3">Rojo</option>
            <option value="2">Amarillo</option>
            <option value="1">Verde</option>
          </select>
        </div>
        <div class="form-group">
          <label for="incidencePlantSoil">Suelo</label>
          <select
            class="form-control"
            [disabled]="incidenceArray[selectedIncidence]?.cantEdit == true"
            [(ngModel)]="incidenceArray[selectedIncidence].soil"
            name="incidencePlantSoil"
            id="incidencePlantSoil"
          >
            <option value="3">Rojo</option>
            <option value="2">Amarillo</option>
            <option value="1">Verde</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</div>
